import React from 'react'
import styled from 'styled-components'

import QuizDiagnosticsDashedLines from './QuizDiagnosticsDashedLines'
import { QUIZ_DIAGNOSTICS_RESPONSIVE_MAX_WIDTH } from '../utils/quizDiagnosticsBreakpoints'
import {
  QUIZ_DIAGNOSTICS_GROUP_BOX_PADDING_BOTTOM,
  QUIZ_DIAGNOSTICS_GROUP_BOX_PADDING_TOP
} from '../utils/quizDiagnosticsBarLayout'

type QuizDiagnosticsGroupBoxProps = {
  children: React.ReactNode
  flexBasis?: string
  flexGrow?: number
  useCompactLayout?: boolean
}

const QuizDiagnosticsGroupBox = ({
  children,
  flexBasis,
  flexGrow = 0,
  useCompactLayout = false
}: QuizDiagnosticsGroupBoxProps): JSX.Element => (
  <Container
    id='quiz-diagnostics-group-box'
    $flexBasis={flexBasis}
    $flexGrow={flexGrow}
  >
    <ChartArea>
      <QuizDiagnosticsDashedLines />
      <BarsContainer $useCompactLayout={useCompactLayout}>
        {children}
      </BarsContainer>
    </ChartArea>
  </Container>
)

export default QuizDiagnosticsGroupBox

const Container = styled.div<{ $flexBasis?: string; $flexGrow: number }>`
  display: flex;
  align-items: stretch;
  justify-content: center;
  background: ${({ theme }) => theme.colors.backgrounds.main};
  border-radius: ${({ theme }) => theme.shape.borderRadiusBig};
  box-shadow: ${({ theme }) => theme.shadows.darkShadow};
  min-height: 140px;
  height: auto;
  padding: 0;
  position: relative;
  overflow: visible;
  flex: ${({ $flexBasis, $flexGrow }) =>
    $flexBasis ? `${$flexGrow} 1 ${$flexBasis}` : `${$flexGrow} 1 0`};
  min-width: 0;
  box-sizing: border-box;

  @media (max-width: ${QUIZ_DIAGNOSTICS_RESPONSIVE_MAX_WIDTH}px) {
    flex: 0 0 100% !important;
    width: 100%;
  }
`

const ChartArea = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 140px;
  padding: 0;
  box-sizing: border-box;
`

const BarsContainer = styled.div<{ $useCompactLayout: boolean }>`
  display: flex;
  flex-wrap: nowrap;
  align-items: ${({ $useCompactLayout }) =>
    $useCompactLayout ? 'flex-start' : 'stretch'};
  justify-content: flex-start;
  width: 100%;
  max-width: 100%;
  flex: 1;
  min-height: 0;
  overflow: visible;
  padding-bottom: ${QUIZ_DIAGNOSTICS_GROUP_BOX_PADDING_BOTTOM}px;
  padding-top: ${QUIZ_DIAGNOSTICS_GROUP_BOX_PADDING_TOP}px;
  box-sizing: border-box;
`
